import { render, staticRenderFns } from "./FullText.vue?vue&type=template&id=021d0d14"
import script from "./FullText.vue?vue&type=script&lang=js"
export * from "./FullText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports